var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 4.57031C11.6367 6.50357 10.07 8.07031 8.13672 8.07031C6.20346 8.07031 4.63672 6.50357 4.63672 4.57031C4.63672 2.63705 6.20346 1.07031 8.13672 1.07031C10.07 1.07031 11.6367 2.63705 11.6367 4.57031ZM8.13672 11.7578C9.1204 11.7578 10.0581 11.5548 10.9099 11.1953H11.2867C13.343 11.1953 15.0117 12.864 15.0117 14.9203V16.3828C15.0117 16.7622 14.7036 17.0703 14.3242 17.0703H1.94922C1.56986 17.0703 1.26172 16.7622 1.26172 16.3828V14.9203C1.26172 12.864 2.93041 11.1953 4.98672 11.1953H5.36426C6.21716 11.5543 7.1518 11.7578 8.13672 11.7578Z",
    stroke: "#999999",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.efc617643086f00405172685ca30b72e.svg";
export { ForwardRef as ReactComponent };